import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionResetMfa } from '../types';

const resetMfa: IActionResetMfa = action(state => {
  state.isMfaRequired = initStore.isMfaRequired;
  state.mfaRequired = initStore.mfaRequired;
});

export default resetMfa;
